import { createContext } from "react";

type AppProviderContextValue = {
  rerenderApp: () => void;
};

export const AppAppProviderContext =
  createContext<null | AppProviderContextValue>(null);
